package com.trevorwiebe.timesheet.loads.presentation

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.trevorwiebe.timesheet.core.presentation.TopBar
import com.trevorwiebe.timesheet.loads.presentation.admin.AdminLoadsScreen
import com.trevorwiebe.timesheet.loads.presentation.admin.LoadsEvent
import com.trevorwiebe.timesheet.loads.presentation.driver.DriverLoadsScreen
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun LoadsScreen(
    onNavigateToCompleted: () -> Unit,
    viewModel: LoadsViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsState()
    val driverState by viewModel.driverState.collectAsState()

    when {
        // Wait for the user before branching so an admin never flashes the driver screen.
        state.userLoading -> Scaffold(
            topBar = { TopBar("Loads") }
        ) { paddingValues ->
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(paddingValues),
                contentAlignment = Alignment.Center
            ) {
                CircularProgressIndicator(
                    color = MaterialTheme.colorScheme.tertiary
                )
            }
        }

        state.userLoadFailed -> Scaffold(
            topBar = { TopBar("Loads") }
        ) { paddingValues ->
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(paddingValues),
                contentAlignment = Alignment.Center
            ) {
                TextButton(
                    onClick = { viewModel.onEvent(LoadsEvent.OnRetryLoadUser) }
                ) {
                    Text("Couldn't load your profile. Tap to retry.")
                }
            }
        }

        state.isElevated -> AdminLoadsScreen(
            state = state,
            onEvent = viewModel::onEvent,
            onNavigateToCompleted = onNavigateToCompleted,
        )

        else -> DriverLoadsScreen(
            state = driverState,
            documentPdfs = state.documentPdfs,
            onEvent = viewModel::onDriverEvent,
        )
    }
}
